import { render, staticRenderFns } from "./Dialog_CreateGoods.vue?vue&type=template&id=b98e4990&scoped=true&"
import script from "./Dialog_CreateGoods.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98e4990",
  null
  
)

export default component.exports